import type constants from '#packages/constants';
import type { AppDefinitionId } from '@wix/document-services-types';

export type NotificationType = ValueOf<typeof constants.NOTIFICATIONS.TYPES>;

export interface Notification {
  id: string;
  name: string;
  title?: string;
  message: string;
  type?: NotificationType;
  origin?: string;
  linkAction?: {
    caption: string;
    onClick: () => void;
    param?: any;
  };
  symbolName?: string;
  shouldTranslate?: boolean;
  timeout?: number;

  timerId?: number;
  startTime?: number;
  appDefinitionId?: AppDefinitionId;
  methodName?: string;
}

export type NotificationsState = Notification[];
